<script>
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrOdenekTalep from "@/models/StrOdenekTalep";
import moment from "moment";
import Swal from "sweetalert2";
import store from "@/state/store";
export default {
  mixins: [Api, Sabit, StrOdenekTalep],
  props: ["Id3"],
  data() {
    return {
      FormData: {},
      Hesapkoduids: [],
      Strperformanshedefiid: "",
      Strtabdetfaaliyetid: "",
      guncele: "Add",
      file: "",
      aktif_arama: false,
      AdminRoleKontrol: false,
      Tarih: moment(new Date()).format("YYYY-MM-DD"),
      FormDatas: [],
      UserEmail : store.getters["auth/UserEMail"],
      Page: {
        PageNumber: "1",
        PageSize: "9999",
      },
      Hesapkodlari: [],
      IptalPersonelId: null,
      OPersonelid: null
    };
  },
  components: {
    formtextarea,
  },
  watch: {
    Id3() {
      this.FormData = this.Id3;

    },
  },
  methods: {
    onSubmit() {


          Swal.fire({
            title: 'Iade İşlemini Onaylıyor Musunuz?',
            text: 'Emin Misiniz?',
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: 'Evet',
            cancelButtonText: 'Hayır',
          }).then((result) => {
            if (result.value) {
var Form = {
  "GrupGuid": this.FormData.GrupGuid,
  "Iptalaciklama":this.FormData.Iptalaciklama,
  "Iptalpersonelid": this.OPersonelid
}
           this.ActionsAllPut({ Service: "StrOdenekTalep/IptalByGrupGuid", Data: Form }).then((res)=> {
            if (res.Succeeded == true) {
            this.OlusturanaMail()
              this.$toast.success(res.Message);
              this.$bvModal.hide("StrOdenekTalepIade");
              this.$emit("TableUpdate");


            } else {
              this.$toast.error(res.Errors);
            }
          });

      }

      });

    },
    GetFormDatas(Id) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ActionsFilterGet({
        Service: "StrOdenekTalep/GetFormDatas",
        Page: Page,
        Filter: "&GrupGuid=" + Id,
      }).then((res) => {
        this.FormDatas = [];
        for (var data in res.Data) {
          this.FormDatas.push(res.Data[data]);
        }
      });
    },
    Get() {
      this.$emit("TableUpdate");
      this.currentDate = new Date();
    },
    OlusturanaMail(){
          this.ActionsSingleGet({
                Service: "opersonel",
                Id: this.FormData.Createdby,
              }).then((res) => {
                  if (res) {


                          let MailData = {
            Message: "Yapmış olduğunuz " + this.FormData.Aciklama + " açıklamalı ödenek talep üzerinde iade talebu bulunmaktadır. İade talebine ait açıklama '" + this.FormData.Iptalaciklama + "' şeklindedir. Sisteme giriş yapıp gerekli düzenlemeleri yapabilir ve ardından tekrar değerlendirmeye gönderebilirsiniz. İyi çalışmalar...",
            Recievermailadress: res.Data.Eposta,
            Subject: "Strateji Bilgi Sistemi"
          };
          this.Post("TsvBildirimTanim/SendInvite", MailData, false).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
            }
          });
                  }else{
                        this.$toast.error('Kaydı oluşturan kişiye mail gönderilemedi.');
                  }

              });






    },

  },
  created() {
    let YetkiSorgu = this.UserRolles.filter(
      (item) => item.includes("SuperAdmin") || item.includes("StrAdmin")
    );
    if (YetkiSorgu.length != 0) this.AdminRoleKontrol = true;

        let Filter = "&Eposta=" + this.UserEMail;
      this.ActionsFilterGet({
        Service: "OPersonel",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.OPersonelid = res.Data[0].Id;
      });

  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrOdenekTalepIade"
      size="xl"
      title="İade"
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <div class="row">
          <div class="row" v-if="AdminRoleKontrol == true">
            <div class="col-md-12">
              <formtextarea
                :FormDataType="FormDataType.Iptalaciklama"
                :Value="FormData.Iptalaciklama"
                :v="$v.FormData.Iptalaciklama"
                @input="FormData.Iptalaciklama = $event"
                :disabled="FormData.Iptal"
              />
            </div>
          </div>
        </div>
        <button class="btn btn-primary" type="submit">
          {{ $t("StrOdenekTalep.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.85;
}
.custom-col {
  flex: 0 0 14%;
  max-width: 14%;
}
.custom2-col {
  flex: 0 0 16%;
  max-width: 16%;
}
</style>
